import { SelectedProductActivity } from "./selected-product-activity"
import { ServiceHour } from "./service-hour"

export class SelectedProduct {
    productId!: string
    selectedProductActivities!: SelectedProductActivity[]
    serviceHours!: ServiceHour[]
}